// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ImportProductThumbnailRequestModel from '../../model/import-product-thumbnail-request-model';
import ImportProductThumbnailRequestDTO from '../dto/import-product-thumbnail-request-dto';

export default abstract class ImportProductThumbnailRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ImportProductThumbnailRequestDTO>) {
    super();
    if (data) {
      this.formFile = data.formFile;
      this.id = data.id;
    }
  }
  /**
  * @type {binary}
  */
  'formFile'?: File;
  /**
  * @type {int64}
  */
  'id'?: number;

  static toModel(dto: DeepPartial<ImportProductThumbnailRequestDTO>): ImportProductThumbnailRequestModel;
  static toModel(dto: DeepPartial<ImportProductThumbnailRequestDTO> | undefined | null): ImportProductThumbnailRequestModel | undefined;
  static toModel(dto: DeepPartial<ImportProductThumbnailRequestDTO> | undefined | null): ImportProductThumbnailRequestModel | undefined {
    return dto ? new ImportProductThumbnailRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ImportProductThumbnailRequestModel> | ImportProductThumbnailRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'formFile': unwrapped.formFile,
      'id': unwrapped.id,
    } as ImportProductThumbnailRequestDTO;
  }
}
